exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir=ltr] modify-room div[content] ul li:not(:last-child){margin-right:30px}[dir=rtl] modify-room div[content] ul li:not(:last-child){margin-left:30px}modify-room div[content] .svg-box,modify-room div[content] .svg-box svg{min-width:30px;max-width:30px;min-height:30px;max-height:30px}modify-room div[content] .guest-icon svg{stroke:#000;stroke-width:13}modify-room div[content] .guest-icon svg path{fill:transparent}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/modify-room/modify-room.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/modify-room/modify-room.component.scss
// module chunks = 0